import { ResourceOptions } from 'react-admin';
import { FaUserFriends } from 'react-icons/fa';
import { Resources } from '../../resource';

import './dataProvider';

export { default as list } from './List';

export const name = Resources.blindBoxSocialFollowers;
export const icon = FaUserFriends;
export const options: ResourceOptions = {
  label: 'module.blindBox.socialFollowers',
};
